//#region src/scripts/utils/shopify-country-selector.js
Shopify.bind = function(fn, scope) {
	return function() {
		return fn.apply(scope, arguments);
	};
};
Shopify.setSelectorByValue = function(selector, value) {
	for (let i = 0, count = selector.options.length; i < count; i++) {
		const option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};
Shopify.addListener = function(target, eventName, callback) {
	target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);
	Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
	this.initCountry();
	this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
	initCountry: function() {
		const value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},
	initProvince: function() {
		const value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) Shopify.setSelectorByValue(this.provinceEl, value);
	},
	countryHandler: function() {
		const raw = this.countryEl.options[this.countryEl.selectedIndex].getAttribute("data-provinces");
		const provinces = JSON.parse(raw);
		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) this.provinceContainer.style.display = "none";
		else {
			for (let i = 0; i < provinces.length; i++) {
				var option = document.createElement("option");
				option.value = provinces[i][0];
				option.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(option);
			}
			this.provinceContainer.style.display = "";
		}
	},
	clearOptions: function(selector) {
		while (selector.firstChild) selector.removeChild(selector.firstChild);
	},
	setOptions: function(selector, values) {
		for (let i = 0; i < values.length; i++) {
			const opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	}
};
//#endregion
//#region src/scripts/base.js
console.log("🐟 Marlin 🐟");
//#endregion
